import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useFirebase } from "../../../context/FirebaseContext";

const AdminPrivateRoute = () => {
  const { currentUser, storeInfo, userRole, loading, authInitialized, error } =
    useFirebase();
  const location = useLocation();

  // Show loading while authentication is being initialized
  if (!authInitialized || loading) {
    return (
      <div className="admin-loading-container">
        <div className="admin-loading-card">
          <div className="loader"></div>
          <h2>Loading...</h2>
          <p>
            {!authInitialized
              ? "Initializing authentication system..."
              : "Checking authentication status..."}
          </p>
        </div>
      </div>
    );
  }

  // Simple authentication check - context has already validated everything
  const isAuthenticated =
    currentUser && userRole === "store_owner" && storeInfo;

  // If there's an authentication error or not authenticated, redirect to login
  if (error || !isAuthenticated) {
    // Provide reason for debugging
    let reason = "Authentication failed";
    if (error) {
      reason = `Authentication error: ${error}`;
    } else if (!currentUser) {
      reason = "No user logged in";
    } else if (userRole !== "store_owner") {
      reason = `Invalid role: ${userRole || "none"}`;
    } else if (!storeInfo) {
      reason = "No store information found";
    }

    return (
      <Navigate
        to="/admin/login"
        state={{
          from: location.pathname,
          reason: reason,
        }}
        replace
      />
    );
  }

  // If authenticated as admin, render the child routes
  return <Outlet />;
};

export default AdminPrivateRoute;
